import './Main.css';
import './Images/Yield.jpg';

const Page = () => {
  return (
    <>
      <div style={{ color: 'black' }}>
        <h1 className="heading">
          Welcome to web-based cyber-platform to estimate alfalfa yield and
          quality to support harvest scheduling
        </h1>
        <div style={{ display: 'flex' }}>
          <div className="intro">
            {' '}
            This is a free public cyberplatform (AlfAdvisor) which will provide
            alfalfa growers with economically optimum harvesting
            recommendations. The platform will include explicit consideration of
            alfalfa growth and quality changes, drying rates and weather-related
            risks incurred during harvest.
          </div>
          <img
            className="image"
            src="https://cms-static.wehaacdn.com/hayandforage-com/images/Screen-Shot-2023-02-09-at-9-59-45-AM__1.6455.jpg"
            alt="yield"
          />
        </div>
      </div>
      <div className="image">
        <p> HeLLo</p>
      </div>
    </>
  );
};

export default Page;
